module.exports = __webpack_public_path__ + "static/media/utilizacionG.f71d7661.png";